export default __webpack_public_path__ + "1f07b6ee14dcd6aa34c630a52f72d593.svg";